import React from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { Loader, NoEposterData } from ".";
import CardItemWithActions from "./CardItemWithActions";

const EPostersGrid = ({ loading, ePosters, actions, truncateWords }) => {
  const history = useHistory();
  const onEPosterClick =
    ({ id }) =>
    () => {
      history.push(`/e-posters/${id}`);
    };

  return (
    <Loader loading={loading}>
      <NoEposterData data={ePosters}>
        <Grid container spacing={3}>
          {ePosters.map(({ id, title, eposterAccademics, thumbUrl }) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={id}>
              <CardItemWithActions
                title={title}
                description={_.uniqBy(eposterAccademics, "profile.id")
                  .map(ea =>
                    `${ea.profile.title || ""} ${ea.profile.firstName} ${
                      ea.profile.lastName
                    }`.trim()
                  )
                  .join(", ")}
                thumbUrl={thumbUrl}
                onClick={onEPosterClick({ id })}
                actions={actions ? actions(id) : []}
                truncateWords={truncateWords}
              />
            </Grid>
          ))}
        </Grid>
      </NoEposterData>
    </Loader>
  );
};

export default EPostersGrid;
